import { makeStyles } from '@material-ui/styles';
import {
    LaNordBold,
    LaNordMedium,
    LaNordRegular,
    InterBold,
    InterSemiBold,
    InterRegular,
} from './fonts';

const useGlobalStyles = makeStyles({
    '@global': {
        html: {
            boxSizing: 'border-box',
            fontSize: '62.5%',
        },

        '*, *:before, *:after': {
            boxSizing: 'inherit',
        },

        '*': {
            WebkitFontSmoothing: 'antialiased',
            MozOsxFontSmoothing: 'grayscale',
        },

        body: {
            margin: 0,
            '-webkit-font-smoothing': 'antialiased',
            '-moz-osx-font-smoothing': 'grayscale',
        },

        '@font-face': [
            LaNordBold,
            LaNordMedium,
            LaNordRegular,
            InterBold,
            InterSemiBold,
            InterRegular,
        ] as unknown as CSSStyleDeclaration,
    },
});

export default useGlobalStyles;
